export const SERVICES = [
  {
    slug: "cataract-surgery",
    name: "Cataract Surgery in Noida",
    tagline: "Premium IOL cataract surgery in Sector 32 Noida — 3000+ surgeries by Dr. Gurkiran Kaur",
    short: "Micro-incision phaco cataract surgery with monofocal, toric, multifocal & trifocal IOLs.",
    icon: "Sparkles",
    keywords: ["cataract surgery Noida", "cataract surgery Sector 32 Noida", "phaco surgery Noida", "premium IOL Noida"],
    what: "We perform micro-incision phacoemulsification cataract surgery with a full range of intraocular lenses — monofocal, toric, multifocal and trifocal — allowing us to tailor the outcome to your visual lifestyle. Complex cataracts including hard, hypermature, subluxated and post-uveitic cases are Dr. Gurkiran Kaur's core surgical strength.",
    includes: [
      "Pre-op biometry with IOL master and topography",
      "Sutureless phacoemulsification (2.2 mm incision)",
      "Premium IOL options: monofocal, toric, multifocal, trifocal",
      "Post-op medications and follow-up for 30 days",
      "Cashless facility with major TPAs",
    ],
    who: "Anyone experiencing blurring, glare at night, faded colours, difficulty reading, or a documented cataract on eye examination.",
    faqs: [
      { q: "Is cataract surgery painful?", a: "No. Modern phaco surgery is done under topical anaesthesia — you feel gentle pressure and see lights, but not pain. Most patients say it was easier than they expected." },
      { q: "How long is the recovery?", a: "Most patients resume light activity the next day. Final vision typically stabilises at 4–6 weeks." },
      { q: "Do I need to stop my blood thinners?", a: "Usually no. Modern phaco surgery is safe on most anticoagulants; we coordinate with your physician." },
      { q: "How much does cataract surgery cost in Noida?", a: "It depends on the IOL. Detailed quotes are provided after evaluation at our clinic in Sector 32 Noida." },
    ],
  },
  {
    slug: "retina-specialist",
    name: "Retina Specialist in Noida",
    tagline: "Diabetic retinopathy, macular disease & retinal disorder care in Sector 32 Noida",
    short: "Retina screening, OCT of the macula, and coordinated care for retinal disorders.",
    icon: "Activity",
    keywords: ["retina specialist Noida", "diabetic retinopathy Noida", "retina screening Noida", "macular disease Noida"],
    what: "Retinal disease often develops silently — diabetic retinopathy, age-related macular degeneration, retinal vein occlusion and retinal detachment can all threaten vision without early warning. We use OCT, digital retinal photography and dilated fundus examination to catch these early and coordinate advanced treatment where needed.",
    includes: [
      "Dilated fundus examination",
      "OCT of the macula and optic nerve",
      "Fundus photography with digital documentation",
      "Diabetic retinopathy screening and grading",
      "Referral pathway for anti-VEGF injections and retinal laser",
    ],
    who: "Every diabetic patient annually, anyone with sudden vision changes, floaters, dark spots, or a family history of macular disease.",
    faqs: [
      { q: "How often should a diabetic get a retina check in Noida?", a: "Yearly — regardless of blood sugar control. Pregnant diabetics need trimester-wise checks." },
      { q: "Is retinal detachment an emergency?", a: "Yes. Sudden floaters, flashes of light or a dark curtain in vision needs same-day evaluation." },
    ],
  },
  {
    slug: "glaucoma-treatment",
    name: "Glaucoma Treatment in Noida",
    tagline: "Complete glaucoma diagnosis, monitoring & treatment in Sector 32 Noida",
    short: "Early detection, monitoring, and treatment of glaucoma — the silent thief of sight.",
    icon: "ShieldAlert",
    keywords: ["glaucoma treatment Noida", "glaucoma specialist Noida", "eye pressure Noida", "OCT nerve Noida"],
    what: "Glaucoma is the leading cause of irreversible blindness worldwide. At Nehchal Eye Centre we combine tonometry, OCT of the optic nerve and automated perimetry to catch glaucoma at its earliest stage — and then we manage it for life with medical, laser and surgical options as needed.",
    includes: [
      "IOP measurement with applanation tonometry",
      "Gonioscopy for angle evaluation",
      "OCT retinal nerve fibre layer analysis",
      "Automated visual field testing",
      "Medical therapy, SLT laser and surgical referral",
    ],
    who: "Everyone over 40 for baseline screening, and anyone with family history, high myopia, long-term steroid use, or diabetes.",
    faqs: [
      { q: "Can glaucoma be cured?", a: "It cannot be cured, but it is very well controlled when caught early. The goal is to preserve vision for life." },
      { q: "How often do I need follow-up?", a: "Stable glaucoma: every 4–6 months. Newly diagnosed or advanced cases: more frequently, based on risk profile." },
    ],
  },
  {
    slug: "pediatric-eye-care",
    name: "Pediatric Eye Care in Noida",
    tagline: "Child-friendly eye care & amblyopia treatment in Sector 32 Noida",
    short: "Specialised eye care for infants, children, and adolescents including amblyopia and squint.",
    icon: "Baby",
    keywords: ["pediatric eye care Noida", "child eye doctor Noida", "amblyopia treatment Noida", "squint Noida"],
    what: "Children rarely complain about their vision because they don&apos;t know what &ldquo;normal&rdquo; looks like. Our pediatric protocol is age-appropriate, gentle, and thorough — designed to detect refractive error, amblyopia, squint, and congenital eye disease as early as possible.",
    includes: [
      "Cycloplegic refraction",
      "Amblyopia (lazy eye) screening and management",
      "Squint (strabismus) evaluation",
      "Retinopathy of prematurity screening (referred as needed)",
      "Vision therapy recommendations",
    ],
    who: "Newborns with red-reflex concerns, toddlers before starting school, children with reading difficulties, headaches or eye rubbing, and any child with a family history of high refractive error.",
    faqs: [
      { q: "When should my child have their first eye check-up?", a: "First formal exam by age 3, and definitely before starting school. Earlier if any concern is noticed at home or by the paediatrician." },
      { q: "Is dilation safe for children?", a: "Yes. Cycloplegic drops are the standard of care for accurate paediatric refraction and are safe when supervised by an ophthalmologist." },
    ],
  },
  {
    slug: "oculoplasty-eyelid-surgery",
    name: "Oculoplasty & Eyelid Surgery in Noida",
    tagline: "Fellowship-trained oculoplasty & eyelid surgery in Sector 32 Noida",
    short: "Blepharoplasty, ptosis correction, DCR and reconstructive eyelid surgery — 500+ procedures.",
    icon: "Wand2",
    keywords: ["oculoplasty Noida", "eyelid surgery Noida", "blepharoplasty Noida", "ptosis Noida", "DCR Noida"],
    what: "Oculoplasty is the eye-focused subspecialty of the eyelids, tear ducts and orbit. Dr. Gurkiran Kaur is fellowship-trained from LVPEI Hyderabad in oculoplasty and has performed over 500 surgical and reconstructive procedures — where every millimetre matters because the surgery is inches from your eye.",
    includes: [
      "Blepharoplasty (upper and lower eyelid surgery)",
      "Ptosis correction for droopy eyelids",
      "Entropion / Ectropion repair",
      "DCR for chronic watering eyes",
      "Reconstructive eyelid surgery after trauma or tumour excision",
    ],
    who: "Patients with droopy or heavy eyelids, chronic watering, cosmetic concerns around the eyes, thyroid eye disease, or trauma-related eyelid deformity.",
    faqs: [
      { q: "Is blepharoplasty a day-care procedure?", a: "Yes. Most upper and lower blepharoplasties are day-care with local anaesthesia — you go home the same day." },
      { q: "How long does eyelid surgery recovery take?", a: "Visible swelling settles in 10–14 days; final result matures over 4–6 weeks." },
    ],
  },
  {
    slug: "periocular-rejuvenation",
    name: "Periocular Rejuvenation in Noida",
    tagline: "Botulinum toxin injections for crow&apos;s feet, brow lift & periocular wrinkles in Sector 32 Noida",
    short: "Precision botulinum toxin injections around the eyes — administered by a fellowship-trained oculoplastic surgeon.",
    icon: "Sparkles",
    keywords: ["periocular rejuvenation Noida", "botulinum toxin around eyes Noida", "crow's feet treatment Noida", "brow lift Noida"],
    what: "Botulinum toxin injections around the eyes soften dynamic wrinkles caused by repeated muscle contraction — the crow&apos;s feet at the corners, the frown lines between the brows, and forehead lines. Because you&apos;re trusting someone with the tissue around your eye, choose an oculoplastic surgeon who knows the anatomy from the inside.",
    includes: [
      "Personalised consultation and facial assessment",
      "Precision unit-dosing per muscle group",
      "Crow&apos;s feet, glabellar and forehead treatment",
      "Chemical brow-lift options",
      "Follow-up review at 2 weeks",
    ],
    who: "Adults with dynamic wrinkles around the eyes and forehead who want a natural, refreshed look — not a frozen one.",
    faqs: [
      { q: "How long does botulinum toxin around the eyes last?", a: "Typically 3–4 months. With regular top-ups the effect can last longer as the muscles learn to relax." },
      { q: "Is botulinum toxin around the eyes safe?", a: "Very safe in trained hands. As an oculoplastic surgeon, Dr. Kaur understands the delicate periocular anatomy — which reduces the risk of drooping eyelids and asymmetry." },
      { q: "When will I see results?", a: "Onset in 3–5 days, full effect at 2 weeks." },
    ],
  },
  {
    slug: "under-eye-fillers",
    name: "Under-Eye Fillers in Noida",
    tagline: "Tear-trough & under-eye hyaluronic acid fillers in Sector 32 Noida",
    short: "Under-eye hollow correction with hyaluronic acid fillers by a fellowship-trained oculoplastic surgeon.",
    icon: "Wand2",
    keywords: ["under eye fillers Noida", "tear trough filler Noida", "dark circles treatment Noida"],
    what: "Under-eye hollows and tear troughs make you look tired even when you&apos;re rested. Hyaluronic acid fillers placed at the correct depth — by someone who has done thousands of surgeries on this exact tissue plane — can restore volume, soften shadows and refresh the whole face without a surgical procedure.",
    includes: [
      "Detailed under-eye assessment (skin, fat, bone)",
      "HA filler placement with cannula (safer, less bruising)",
      "Numbing before the procedure",
      "Same-day return to work",
      "Follow-up at 2 weeks for touch-up if needed",
    ],
    who: "Adults with genuine tear-trough hollowing, dark circles from shadows (not pigmentation), or age-related under-eye volume loss.",
    faqs: [
      { q: "How long do under-eye fillers last?", a: "Typically 9–12 months for hyaluronic acid fillers. The under-eye area often lasts longer than lips or cheeks." },
      { q: "Is filler safe in the under-eye area?", a: "Yes — when done with the right product, cannula technique, and anatomical knowledge. Choose an oculoplastic surgeon over a non-specialist for this region." },
      { q: "Can under-eye fillers be dissolved?", a: "Yes. HA fillers can be dissolved with hyaluronidase if the result is not what you want — one of the safety advantages of HA over permanent fillers." },
    ],
  },
  {
    slug: "dry-eye-treatment",
    name: "Dry Eye Treatment in Noida",
    tagline: "Comprehensive dry eye diagnosis & treatment in Sector 32 Noida",
    short: "From lubricants to punctal plugs — a step-wise approach for chronic dry eye and screen-strain.",
    icon: "Focus",
    keywords: ["dry eye treatment Noida", "dry eye clinic Noida", "computer vision syndrome Noida"],
    what: "Dry eye is one of the most under-treated eye conditions in India — especially among IT professionals, contact-lens wearers and post-menopausal women. It is not just an inconvenience; untreated dry eye damages the corneal surface and blurs vision. We evaluate the root cause and treat it in a step-wise, evidence-based way.",
    includes: [
      "Tear film assessment (Schirmer, TBUT, meibography)",
      "Meibomian gland dysfunction evaluation",
      "Personalised lubricant regimen",
      "Warm compress and lid hygiene training",
      "Punctal plugs and prescription drops when indicated",
    ],
    who: "Anyone with burning, gritty, watery or fluctuating vision — especially screen-heavy professionals, contact lens users, and post-LASIK patients.",
    faqs: [
      { q: "What causes dry eyes?", a: "Age, screen use, contact lenses, hormonal changes, LASIK, autoimmune disease and Noida&apos;s dry, dusty air all contribute. Treatment starts with identifying which factors apply to you." },
      { q: "Are eye drops enough for dry eye?", a: "Often, but not always. Chronic dry eye needs a step-wise plan — lubricants, lid hygiene, sometimes prescription anti-inflammatory drops or punctal plugs." },
    ],
  },
  {
    slug: "emergency-eye-care",
    name: "Emergency Eye Care in Noida",
    tagline: "Same-day eye emergencies at our Sector 32 Noida clinic",
    short: "Corneal foreign body, chemical burns, trauma, sudden vision loss — same-day evaluation.",
    icon: "AlertTriangle",
    keywords: ["emergency eye care Noida", "eye injury Noida", "corneal foreign body Noida", "sudden vision loss Noida"],
    what: "Eye emergencies are real emergencies. From corneal foreign bodies and chemical splashes to blunt trauma, sudden vision loss and painful red eyes — timely, expert care preserves vision. Call the clinic and we will fit you in the same day.",
    includes: [
      "Same-day evaluation for eye trauma and infection",
      "Corneal foreign body removal",
      "Chemical burn irrigation and management",
      "Lid laceration repair",
      "Assessment of sudden vision loss and painful red eyes",
    ],
    who: "Anyone with recent eye trauma, chemical splash, sudden vision loss, sudden floaters, severe eye pain, or a red painful eye.",
    faqs: [
      { q: "What should I do immediately after a chemical splash?", a: "Irrigate the eye with clean water for 15 minutes and come to the clinic immediately. Do not wait." },
      { q: "My eye was hit — should I still come in even if it feels okay?", a: "Yes. Some complications like retinal tears or delayed haemorrhage appear days after the injury. A one-time check is worth it." },
    ],
  },
  {
    slug: "comprehensive-examination",
    name: "Comprehensive Eye Examination in Noida",
    tagline: "Complete eye health assessment in Sector 32 Noida",
    short: "Full-spectrum eye evaluation — refraction, IOP, retina, and screening in one visit.",
    icon: "Eye",
    keywords: ["comprehensive eye examination Noida", "eye test Sector 32 Noida", "eye specialist Noida"],
    what: "A comprehensive eye examination at Nehchal Eye Centre in Noida evaluates every layer of ocular health — from refraction and binocular function to the optic nerve and retina. It is the foundation of preventive eye care and often catches sight-threatening conditions before you notice symptoms.",
    includes: [
      "Auto-refraction and subjective refraction",
      "Slit lamp examination of the anterior segment",
      "Intraocular pressure measurement",
      "Dilated fundus and retina evaluation",
      "Colour vision, contrast sensitivity, stereopsis screening as needed",
    ],
    who: "Recommended annually for adults over 40, diabetics, hypertensives, screen-heavy professionals, and anyone with a family history of glaucoma or macular disease.",
    faqs: [
      { q: "How long does a comprehensive eye exam take?", a: "Typically 30 to 45 minutes. If dilation is required, please allow 60–75 minutes and arrange transport as vision stays blurred for a few hours." },
      { q: "Will I get a prescription the same day?", a: "Yes, refraction results and any recommended prescription are shared during the same visit." },
    ],
  },
  {
    slug: "refractive-surgery",
    name: "Refractive Surgery in Noida",
    tagline: "LASIK, SMILE & ICL consultation in Sector 32 Noida",
    short: "Freedom-from-glasses evaluation and personalised procedure recommendation.",
    icon: "Focus",
    keywords: ["refractive surgery Noida", "LASIK consultation Noida", "SMILE Noida", "ICL Noida"],
    what: "If you want freedom from glasses or contact lenses, we begin with a detailed refractive workup to determine whether LASIK, PRK, SMILE or ICL is the safest option for your cornea and lifestyle. Not everyone is a candidate — and that is the most important step.",
    includes: [
      "Corneal topography and pachymetry",
      "Wavefront analysis",
      "Dry eye evaluation",
      "Personalised procedure recommendation",
      "Coordinated surgical scheduling",
    ],
    who: "Adults over 18 with stable prescription for at least a year, no active eye disease, and healthy corneal thickness.",
    faqs: [
      { q: "Is LASIK permanent?", a: "LASIK permanently reshapes the cornea. Age-related changes (presbyopia, cataract) still develop naturally and are managed separately." },
    ],
  },
  {
    slug: "neuro-ophthalmology",
    name: "Neuro Ophthalmology in Noida",
    tagline: "Neuro-ophthalmology consultation in Sector 32 Noida",
    short: "Treatment of visual disorders related to the nervous system — double vision, optic nerve issues, sudden vision loss.",
    icon: "Brain",
    keywords: ["neuro ophthalmology Noida", "optic neuritis Noida", "double vision Noida"],
    what: "Neuro-ophthalmology sits at the interface of the eye and the nervous system. Sudden loss of vision, double vision, unequal pupils and optic nerve swelling all require prompt evaluation and often coordinated care with a neurologist.",
    includes: [
      "Cranial nerve examination",
      "Optic nerve imaging with OCT",
      "Visual field testing",
      "Coordinated care with neurology when required",
    ],
    who: "Anyone with sudden vision loss, double vision, drooping eyelid, unequal pupils, or unexplained headaches with visual symptoms.",
    faqs: [
      { q: "Is double vision an emergency?", a: "New-onset double vision needs same-day evaluation. Call the clinic and we will fit you in." },
    ],
  },
];

export const findService = (slug) => SERVICES.find((s) => s.slug === slug);
